import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ENVIRONMENT } from '@cfp/core';
import { EnvironmentCodeDTO } from 'csr-login-app';

@Component({
  selector: 'cfp-footer-text',
  templateUrl: './footer-text.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FooterText {
  protected readonly environment = inject(ENVIRONMENT);
  protected readonly EnvironmentCodeDTO = EnvironmentCodeDTO;
}
